module.exports = __webpack_public_path__ + "img/icon_service_02.44331dcf.png";